<template>
  <li class="col-12 col-md-6 questionare-item" @click="answer">
    <span><slot></slot></span>
    <span class="btn-answer">回答する</span>
  </li>
</template>

<script>
export default {
  name: "QuestionareItem",
  props: {
    href: { type: String, default: "" },
  },
  methods: {
    answer() {
      window.open(this.$props.href + this.$parent.userid, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.questionare-item {
  padding: 20px;
  border-bottom: 1px solid $secondary;
  border-left: 1px solid $secondary;
  border-right: 1px solid $secondary;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  @include mq-up(md) {
    padding: 30px;
  }
  &:nth-of-type(1) {
    border-top: 1px solid $secondary;
  }
  &:nth-of-type(2) {
    @include mq-up(md) {
      border-top: 1px solid $secondary;
    }
  }
  &:nth-child(even) {
    @include mq-up(md) {
      border-left: none;
    }
  }
  &:hover {
    > :nth-child(n) {
      opacity: 0.7;
    }
  }
  > .btn-answer {
    border: 1px solid $secondary;
    border-radius: 20px;
    text-align: center;
    font-size: 12px;
    line-height: 100%;
    padding: 8px 15px;
    @include mq-up(md) {
      font-size: 14px;
      padding: 10px 25px;
    }
  }
}
</style>
